// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"0ed0cae0","247":"b9f63179","422":"8c1a9d54","627":"cdf943de","768":"3c1c8a66","834":"c09eb069","867":"c917b9d1","923":"693fd11d","938":"b19cf370","950":"53dfc835"}[chunkId] + ".chunk.js";
};